import React from 'react';

// Paleta estável (mesma ordem = mesma cor entre renders). Cores do tema Volt + extras.
const PALETTE = [
    '#1b998b', '#f5b759', '#fa5252', '#4c6ef5', '#a855f7',
    '#20c997', '#fd7e14', '#e64980', '#15aabf', '#82c91e',
];

function polar(cx, cy, r, angle) {
    const a = (angle - 90) * Math.PI / 180;
    return { x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) };
}

function slicePath(cx, cy, r, start, end) {
    // Slice único de 100% → círculo completo (o A não fecha 360°). Desenha 2 semicírculos.
    if (end - start >= 359.999) {
        return `M ${cx - r} ${cy} A ${r} ${r} 0 1 1 ${cx + r} ${cy} A ${r} ${r} 0 1 1 ${cx - r} ${cy} Z`;
    }
    const s = polar(cx, cy, r, start);
    const e = polar(cx, cy, r, end);
    const largeArc = end - start > 180 ? 1 : 0;
    return `M ${cx} ${cy} L ${s.x} ${s.y} A ${r} ${r} 0 ${largeArc} 1 ${e.x} ${e.y} Z`;
}

/**
 * Pizza de alocação em SVG puro (sem dependência).
 * props:
 *  - data: [{ label, value }]  (valores >= 0; fatias < minPct são agrupadas em "Outros")
 *  - size: diâmetro em px (default 160)
 *  - money: formata o valor na legenda? (default true → $X.XX)
 *  - color: cor do texto da legenda (default inherit; use claro em fundo escuro)
 *  - minPct: fatias abaixo deste % do total são agrupadas em "Outros" (default 0.03).
 *            Passe 0 pra NÃO agrupar (ex.: comparação de 2 categorias como Spot×Futuros).
 */
function PieChart({ data, size = 160, money = true, color, minPct = 0.03 }) {
    const rows = (data || []).filter(d => parseFloat(d.value) > 0);
    const total = rows.reduce((s, d) => s + parseFloat(d.value), 0);
    if (!total) return <p className='text-muted small mb-0'>Sem dados para exibir.</p>;

    // Agrupa fatias < minPct em "Outros" pra não poluir (minPct=0 desliga).
    const MIN = minPct;
    const big = [], small = [];
    rows.sort((a, b) => b.value - a.value).forEach(d => (d.value / total >= MIN ? big : small).push(d));
    const otherVal = small.reduce((s, d) => s + parseFloat(d.value), 0);
    const slices = otherVal > 0 ? [...big, { label: 'Outros', value: otherVal }] : big;

    const cx = size / 2, cy = size / 2, r = size / 2;
    let acc = 0;
    const fmt = v => money ? `$${parseFloat(v).toFixed(2)}` : `${parseFloat(v).toFixed(0)}`;

    return (
        <div className='d-flex align-items-center flex-wrap gap-3'>
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                {slices.map((d, i) => {
                    const frac = d.value / total;
                    const start = acc * 360;
                    acc += frac;
                    const end = acc * 360;
                    return <path key={d.label} d={slicePath(cx, cy, r, start, end)} fill={PALETTE[i % PALETTE.length]} stroke='#0b1220' strokeWidth='1' />;
                })}
            </svg>
            <ul className='list-unstyled mb-0' style={{ fontSize: 13, minWidth: 140, color }}>
                {slices.map((d, i) => (
                    <li key={d.label} className='d-flex justify-content-between align-items-center mb-1'>
                        <span className='d-flex align-items-center'>
                            <span style={{ width: 10, height: 10, borderRadius: 2, background: PALETTE[i % PALETTE.length], display: 'inline-block', marginRight: 6 }} />
                            {d.label}
                        </span>
                        <span className='text-muted ms-3'>{fmt(d.value)} · {((d.value / total) * 100).toFixed(0)}%</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default PieChart;
